import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import SiteGlobe from './icon-site-globe.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <SiteGlobe {...validProps} fill={validProps.fill || validProps.color} />;
}
SvgComponent.iconName = 'site-globe';

export const SiteGlobeIcon = svgIconWrapper(SvgComponent);
